import { apiUrl } from '.';
import { authService } from './';

const internalReport = async (year) => {
    const requestOptions = {
        method: 'GET'
    };

    const res = await authService.handleResponse(apiUrl + '/reports/internal?year='+year, requestOptions);
    return res;
}

const internalReportExport = async (year) => {
    const requestOptions = {
        method: 'GET',
        xhrFields: {
            responseType: 'blob'
        },
    };

    const res = await authService.handleResponse(apiUrl + '/reports/csv/internal?year=' + year, requestOptions, true);
    return res;
}

const AAUSReport = async (year) => {
    const requestOptions = {
        method: 'GET'
    };

    const res = await authService.handleResponse(apiUrl + '/reports/aaus?year='+year, requestOptions);
    return res;
}

const aausDetails = async (year, type, page, sortField, sortOrder, pages = 1) => {
    const requestOptions = {
        method: 'GET'
    };

    const res = await authService.handleResponse(apiUrl + '/reports/aaus/'+year+'/'+type+'?page='+page + (pages > 1 ? '&pages='+pages : '') + (sortField ? '&sortField='+sortField : '') + (sortOrder !== null ? '&sortOrder='+sortOrder : ''), requestOptions);
    return res;
}

const AAUSReportExport = async (year) => {
    const requestOptions = {
        method: 'GET',
        xhrFields: {
            responseType: 'blob'
        },
    };

    const res = await authService.handleResponse(apiUrl + '/reports/csv/aaus?year=' + year, requestOptions, true);
    return res;
}

const expirationReport = async (data) => {
    const requestOptions = {
        method: 'GET'
    };

    const res = await authService.handleResponse(apiUrl + '/reports/expiration?type='+data.type+'&date='+data.date, requestOptions);
    return res;
}

const attendanceReport = async (data) => {
    const requestOptions = {
        method: 'GET'
    };

    const res = await authService.handleResponse(apiUrl + '/reports/attendance?startDate='+data.startDate+'&endDate='+data.endDate, requestOptions);
    return res;
}

const diversReport = async () => {
    const requestOptions = {
        method: 'GET'
    };

    const res = await authService.handleResponse(apiUrl + '/reports/divers', requestOptions);
    return res;
}

const speciesReportInfo = async () => {
    const requestOptions = {
        method: 'GET'
    };

    const res = await authService.handleResponse(apiUrl + '/reports/species/info', requestOptions);
    return res;
}

const speciesReport = async (data) => {
    const requestOptions = {
        method: 'GET'
    };

    const res = await authService.handleResponse(apiUrl + '/reports/species?species='+data.species+'&date='+data.date, requestOptions);
    return res;
}

const commProblemsReport = async (data) => {
    const requestOptions = {
        method: 'GET'
    };

    const res = await authService.handleResponse(apiUrl + '/reports/comm-problems?dateStart='+data.dateStart+'&dateEnd='+data.dateEnd, requestOptions);
    return res;
}

export const reportService = {
    internalReport,
    internalReportExport,
    AAUSReport,
    AAUSReportExport,
    expirationReport,
    diversReport,
    speciesReportInfo,
    speciesReport,
    commProblemsReport,
    attendanceReport,
    aausDetails
};